<template>
  <section class="section">
    <div class="header">
      <div class="backBtn" v-on:click="$router.back()"></div>
      <h4>Galeri perubahan</h4>
    </div>
    <div class="menuCnt">
      <div class="menuItem loadingPrice" v-if="loading"></div>
      <div v-else class="historyCnt">
        <div v-for="(item, i) in history" :key="i" class="historyItem">
          <h4>{{item.dateCreated | moment("ddd, D MMM YYYY HH:mm")}}</h4>
          <div class="menuItem">
            <div class="menuItemCnt">
              Body Composition
              <div class="bcCnt">
                <div class="bcItem weight">
                  Berat Badan<span>{{item.bodyWeight}} kg</span>
                </div>
                <div class="bcItem">
                  Lingkar Pinggang<span>{{item.waistSize}} cm</span>
                </div>
                <div class="bcItem bmi">
                  BMI<span>{{item.bmi.toLocaleString('id', { maximumFractionDigits: 2 })}}</span>
                </div>
                <div class="bcItem bmi">
                  BMR<span>{{item.bmr.toLocaleString('id', { maximumFractionDigits: 2 })}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="menuItem" v-if="item.photos && item.photos.length > 0">
            <div class="menuItemCnt">
              Foto
              <div class="photoCnt" v-viewer="options">
                <div class="photoItem" v-for="(photo, ip) of item.photos" :key="ip">
                  <div class="thePhotoImgCnt">
                    <img class="thePhotoImg" :data-src="photo.uri" :src="photo.uri">
                  </div>
                  <!-- <div class="thePhoto"
                    :style="{'background-image': `url(${photo.uri})`}"></div> -->
                  <h4 v-if="photo.label === 'depan'">Foto depan</h4>
                  <h4 v-else-if="photo.label === 'belakang'">Belakang</h4>
                  <h4 v-else-if="photo.label === 'samping'">Samping</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Confirmation ref="confirmDialog"/>
  </section>
</template>

<script>
import Confirmation from '@/components/Confirmation.vue';

export default {
  name: 'home',
  components: { Confirmation },
  data() {
    return {
      st: 'reg',
      point: 6000,
      loading: true,
      history: [],
      options: {
        url: 'data-src',
        title: false,
        movable: false,
        zoomOnWheel: false,
        slideOnTouch: true,
      },
    };
  },
  created() {
  },
  destroyed() {
  },
  methods: {
    doNothing() {},
    rand(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    },
    claim(item, i) {
      this.price[i].claimed = true;
      this.$http.get(this.$config.uri(`user/price/${item.id}/claim`)).then((r) => {});
    },
    logout() {
      this.$refs.confirmDialog.open({
        title: 'Keluar',
        desc: 'Apakah kamu yakin ingin keluar? Kamu dapat masuk kembali kapan aja.',
        action: 'Keluar',
      });
    },
  },
  mounted() {
    // Check login
    if (!this.$session.get('bk6_email')) {
      this.$router.push('/login');
      return;
    }
    this.$http.get(this.$config.uri('user/status')).then((r) => {
      if (r.data.status !== 200) {
        this.$session.destroy();
        this.$router.push('/login');
      }
    });
    this.$http.get(this.$config.uri('user/photo/history')).then((r) => {
      this.loading = false;
      this.history = (r.data.status === 200) ? r.data.data : [];
    });
  },
};
</script>

<style scoped lang="scss">
.section{
}
.historyCnt{
  margin-top: -20px;
  .historyItem{
    padding-top: 30px;;
  }
}
.header{
  padding: 16px 20px 0;
  @media (min-width: 480px) {
    padding-left: 10px;
  }
  .backBtn{
    width: 46px; height: 46px;
    border-radius: 50%;
    background-color: #fff;
    background-image: url(../assets/arrow-back.png);
    background-size: 22px auto;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
    transition: all .3s ease;
    &:hover{
      background-color: #f5f5f5;
    }
  }
  h4{
    font-size: 24px;
    margin: 16px 0 6px;
    color: #006519;
  }
}
.profilePict{
  width: 94px; height: 94px;
  background-color: #ccc;
  border-radius: 50%;
  margin: 0 auto 16px;
  background-image: url(../assets/bruno-mars.jpg);
  background-position: center;
  background-size: cover;
}
.profileInfo{
  text-align: center;
  padding-bottom: 20px;
  h4{
    margin: 0;
    font-size: 20px;
  }
  p{
    margin: 0;
    font-size: 15px;
  }
}
.expCnt{
  background-color: rgba(255, 255, 255, .5);
  margin: 0 10px 10px;
  border-radius: 10px;
  padding: 16px 20px 20px;
  position: relative;
  h4{
    margin: 0 0 6px;
    font-size: 16px;
  }
  .expLabel{
    position: absolute;
    right: 20px; top: 18px;
    font-size: 14px;
  }
  .theExp{
    height: 12px;
    background-color: #ccc;
    border-radius: 50px;
    .exp{
      height: 100%;
      max-width: 100%;
      background-color: #8EC642;
      // background-color: #6aa722;
      border-radius: 50px;
    }
  }
  .info{
    font-size: 12px;
    color: #555;
    text-align: right;
    margin: 5px 5px 0;
  }
}
.progressCnt{
  background-color: rgba(255, 255, 255, .5);
  margin: 0 10px;
  border-radius: 10px;
  padding: 16px 20px 52px;
  h4{
    margin: 0 0 10px;
  }
  .theProgress{
    display: flex;
    height: 80px;
    justify-content: space-between;
    .progressItem{
      height: 100%;
      font-size: 10px;
      text-align: center;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      position: relative;
      .label{
        position: absolute;
        left: 50%; margin-left: -15px;
        text-align: center;
        bottom: -34px;
        width: 30px;
        span{
          display: block;
          font-size: 14px;
          font-weight: bold;
          margin-top: -1px;
        }
      }
      .progress{
        width: 8px;
        background-color: #8EC642;
        background-color: #6aa722;
        border-radius: 10px;
        margin: 0 auto;
      }
    }
  }
}
.menuCnt{
  padding: 10px 0 40px;
  h4{
    margin: 0 20px 6px;
  }
  .divider{
    height: 20px;
  }
  .menuItem{
    padding: 16px 20px;
    font-weight: bold;
    color: #444;
    position: relative;
    background-color: rgba(255, 255, 255, .6);
    background-color: #fff;
    // background-image: linear-gradient(to left, #8EC642, #669922);
    // color: #fff;
    margin: 0 10px 10px;
    border-radius: 5px;
    font-size: 17px;
    min-height: 80px;
    box-sizing: border-box;
    &.loadingPrice{
      background-color: rgba(255, 255, 255, 0.5);
      background-color: transparent;
      background-image: url(../assets/loading.svg);
      background-position: center;
      background-repeat: no-repeat;
      background-size: 36px auto;
      height: 60px;
    }
    .bcCnt{
      display: flex;
      flex-wrap: wrap;
      padding-top: 8px;
      @media (max-width: 410px) {
        margin-bottom: -10px;
      }
      .bcItem{
        font-size: 13px;
        font-weight: normal;
        width: 32%;
        color: #767676;
        @media (max-width: 410px) {
          width: 50% !important;
          margin-bottom: 10px;
        }
        &.weight{
          width: 26%;
        }
        &.bmi{
          width: 21%;
        }
        span{
          display: block;
          font-weight: bold;
          font-size: 20px;
          color: #444;
        }
      }
    }
    .photoCnt{
      display: flex;
      margin: 0 -5px;
      padding-top: 8px;
      .photoItem{
        width: calc(33.3333% - 10px);
        margin: 0 5px;
        .thePhotoImgCnt{
          position: relative;
          height: 127px;
          overflow: hidden;
          background-color: #eee;
          border-radius: 5px;
          .thePhotoImg{
            cursor: pointer;
            position: absolute;
            max-width: 100%;
            max-height: 100%;
            top: -9999px;
            left: -9999px;
            right: -9999px;
            bottom: -9999px;
            margin: auto;
          }
        }
        .thePhoto{
          border-radius: 5px;
          background-color: #222;
          height: 126px;
          background-position: center;
          background-size: cover;
        }
        h4{
          font-size: 14px;
          margin: 4px 0 0;
          text-align: center;
        }
      }
    }
  }
}

</style>
